module.exports = __webpack_public_path__ + "media/gallery/berlin-3-min-9275d372.webp";